import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SeoPreviewSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
            <div className="lg:col-span-5">
              <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-600 border border-foreground-300 rounded-md mb-6">
                {t('seo.label')}
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
                {t('seo.title_line1')}
              </h2>
              <h3 className="font-heading text-3xl md:text-4xl font-normal text-foreground-600 mb-8">
                {t('seo.title_line2')} <span className="text-accent-500">📊</span>
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
                {t('seo.summary')}
              </p>
              <Link
                to="/yoybuy-sheet-guide"
                className="inline-flex items-center gap-2 text-foreground-950 font-semibold text-sm border-b-2 border-foreground-950 pb-1 hover:text-accent-500 hover:border-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('seo.read_more')}
              </Link>

              <div className="flex flex-wrap gap-2 mt-8">
                <Link to="/yoybuy-sheet-guide" className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-600 text-xs hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap">
                  yoybuy sheet 2026
                </Link>
                <Link to="/yoybuy-sheet-guide" className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-600 text-xs hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap">
                  spreadsheet-таблицы
                </Link>
                <Link to="/yoybuy-sheet-guide" className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-600 text-xs hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap">
                  Taobao deals
                </Link>
                <Link to="/yoybuy-sheet-guide" className="px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-600 text-xs hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap">
                  шопинг из Китая
                </Link>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="relative">
                <div className="flex justify-end mb-4 gap-10 md:gap-14">
                  <div className="text-right">
                    <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">70%</p>
                    <p className="text-foreground-500 text-xs mt-1">{t('stats.savings')}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">5000+</p>
                    <p className="text-foreground-500 text-xs mt-1">{t('stats.products')}</p>
                  </div>
                </div>

                <div className="relative">
                  <div className="w-[60%] h-64 md:h-80 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Fashion%20products%20flat%20lay%20with%20spreadsheet%20screenshot%20on%20laptop%20screen%2C%20warm%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20modern%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20shopping%20deals%20and%20data%20concept&width=600&height=800&seq=seo-preview-img-01&orientation=portrait"
                      alt="Yoybuy Sheet guide"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute top-8 right-0 w-[55%] h-56 md:h-72 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Trendy%20sneakers%20and%20accessories%20arranged%20on%20warm%20cream%20surface%2C%20minimal%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20style%2C%20neutral%20warm%20tones%2C%20fashion%20lifestyle%20aesthetic%2C%20elegant%20composition&width=600&height=800&seq=seo-preview-img-02&orientation=portrait"
                      alt="Kaspreadsheet products"
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}